// Text constants for ListsNull component
const NullViewTexts = {
  cardTitle: 'Make a List. Get What You Need. Plan the Job.',
  benefits: [
    'Organize supply needs by property, job type, or region',
    'Use lists to plan and prepare bids',
    'Share lists with team and clients'
  ],
  imageAlt: 'Placeholder image',
  cta: 'Create List',
  learnMoreText: 'Learn More',
  // imageUrl: 'https://dam.thdstatic.com/content/production/nlPKlSIZxxlMYYBB5rujfg/2DcEm3xMy_0doFmVCQnSrQ/'
  // + 'Contentful%20Hero%2016:10/2023_ProCustom_Handyman_Cabinet_Install_0707_v3_Contentful%20Hero%201610.jpg',
  imageUrl: 'https://dam.thdstatic.com/content/production/nlPKlSIZxxlMYYBB5rujfg/2DcEm3xMy_0doFmVCQnSrQ/'
  + 'Contentful%20Hero%2016:10/2023_ProCustom_Handyman_Cabinet_Install_0707_v3_Contentful%20Hero%201610.jpg'
};

export default NullViewTexts;
